// Reuse these styles on custom controls as well as the shared Button. Colors
// stay live through CSS tokens, including controls rendered in portals.
export const accentButtonStyle = {
  background: 'var(--accent-fill, var(--accent-bg))',
  color: 'var(--accent-text)',
  border: '1px solid var(--accent-border)',
  fontWeight: 600,
};
